import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import CountUp from "react-countup";
const stats = [
  { value: 10000, suffix: "+", label: "Visas Processed" },
  { value: 120, suffix: "+", label: "Countries Covered" },
  { value: 98, suffix: "%", label: "Approval Rate" },
  { value: 24, suffix: "/7", label: "Expert Support" },
];
function StatItem({ stat, index }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  return (
    <motion.div ref={ref} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      transition={{ delay: index * 0.1 }} className="text-center" data-testid={`stat-${index+1}`}>
      <div className="stat-number text-4xl md:text-5xl text-slate-900 mb-1">
        {isInView ? <CountUp end={stat.value} duration={2.5} separator="," /> : "0"}
        <span className="text-blue-600">{stat.suffix}</span>
      </div>
      <p className="text-sm text-slate-500">{stat.label}</p>
    </motion.div>
  );
}
export default function Stats() {
  return (
    <section id="stats" data-testid="stats-section" className="py-20 md:py-28 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="card-elevated rounded-2xl p-10 md:p-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">{stats.map((s, i) => <StatItem key={s.label} stat={s} index={i} />)}</div>
        </div>
      </div>
    </section>
  );
}
